import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiFacebook, FiLinkedin, FiTwitter } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-alpha-navyDark text-white pt-20 pb-10 border-t border-white/10">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          <div className="col-span-1 lg:col-span-1">
            <img 
              src="https://res.cloudinary.com/dfg8nrgvf/image/upload/v1782378834/Remove_Background_17322517_peesjl.png" 
              alt="Alpha Training Consultancy Logo" 
              className="h-16 mb-6 brightness-0 invert"
            />
            <p className="text-alpha-grayLight/70 text-sm leading-relaxed mb-6">
              Building safer workplaces through premium knowledge and comprehensive workforce training solutions in Singapore.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-alpha-green transition-colors">
                <SafeIcon icon={FiLinkedin} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-alpha-green transition-colors">
                <SafeIcon icon={FiFacebook} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-alpha-green transition-colors">
                <SafeIcon icon={FiTwitter} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3 text-alpha-grayLight/70 text-sm">
              <li><a href="#about" className="hover:text-alpha-green transition-colors">About Us</a></li>
              <li><a href="#services" className="hover:text-alpha-green transition-colors">Our Services</a></li>
              <li><a href="#programs" className="hover:text-alpha-green transition-colors">Training Catalogue</a></li>
              <li><a href="#journey" className="hover:text-alpha-green transition-colors">The Alpha Journey</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6">Popular Programs</h4>
            <ul className="space-y-3 text-alpha-grayLight/70 text-sm">
              <li><a href="#" className="hover:text-alpha-green transition-colors">Construction Safety</a></li>
              <li><a href="#" className="hover:text-alpha-green transition-colors">Domestic Worker SIP</a></li>
              <li><a href="#" className="hover:text-alpha-green transition-colors">Foreign Worker Induction</a></li>
              <li><a href="#" className="hover:text-alpha-green transition-colors">Corporate Compliance</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-lg mb-6">Accreditations</h4>
            <p className="text-alpha-grayLight/70 text-sm leading-relaxed mb-4">
              Our programs are designed in compliance with national standards and accredited by relevant governing bodies in Singapore.
            </p>
            <div className="flex gap-4 items-center">
              {/* Placeholders for accreditation logos */}
              <div className="w-16 h-12 bg-white/10 rounded flex items-center justify-center text-xs text-white/50">MOM</div>
              <div className="w-16 h-12 bg-white/10 rounded flex items-center justify-center text-xs text-white/50">WSHC</div>
            </div>
          </div>

        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-alpha-grayLight/50 text-sm">
            © {new Date().getFullYear()} Alpha Training Consultancy. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-alpha-grayLight/50">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;